import React from 'react';

interface WizardStep {
    number: number;
    label: string;
}

interface WizardProgressProps {
    steps: WizardStep[];
    currentStep: number;
    className?: string;
}

const WizardProgress: React.FC<WizardProgressProps> = ({ steps, currentStep, className = '' }) => {
    return (
        <div className={`wizard-progress margin-vertical-4 ${className}`}>
            <div className="row align-items-center wizard-progress-top">
                {steps.map((step, index) => (
                    <React.Fragment key={step.number}>
                        <div className="column-auto">
                            <div
                                className={`wizard-step ${
                                    step.number === currentStep
                                        ? 'active'
                                        : step.number < currentStep
                                        ? 'completed'
                                        : 'pending'
                                }`}
                            >
                                <div className="wizard-step-number">
                                    {step.number}
                                </div>
                                <div className="wizard-step-label">{step.label}</div>
                            </div>
                        </div>
                    </React.Fragment>
                ))}
            </div>
        </div>
    );
};

export default WizardProgress;
